/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { useHistory } from "react-router-dom";

import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";

import IssueForm from "../../../../../presentation/pages/developer/issue/form";

import toastUtils from "../../../../../utils/ToastUtils";
import { getErrorMessage } from "../../../../../presentation/helpers";

import { makeRemoteDeveloperCompanies } from "../../../usecases/developer-companies/remote-developer-companies-factory";
import { makeRemoteFiscalNote } from "../../../usecases/fiscal-note/remote-fiscal-note-factory";
import { NFSeTypeEnum } from "../../../../../presentation/enums/nfs-e-type.enum";

const MakeIssue: React.FC = () => {
  const [developerCompaniesList, setDeveloperCompaniesList] = React.useState<
    DeveloperCompanyModel[]
  >([]);

  const [submitting, setSubmitting] = React.useState<boolean>(false);

  const history = useHistory();

  React.useEffect(() => {
    (async () => {
      const econ = await makeRemoteDeveloperCompanies().getByDeveloper();

      setDeveloperCompaniesList(econ);
    })();
  }, []);

  const handleSubmit = async (
    values: any,
    setShowConfirm: any,
  ): Promise<void> => {

    setSubmitting(true);
    try {
      if (!values?.taker?.id) {
        toastUtils.showMessage({
          type: "warning",
          message: "Por favor, selecione um tomador!",
        });
        setSubmitting(false);
        return;
      }

      const toSend = {
        developerCompany: {
          id: values?.company,
        },
        observation: values?.description,
        serviceList: [
          {
            conditionedDiscount: Number(
              values?.conditionedDiscount
                ?.replaceAll(".", "")
                .replaceAll(",", "."),
            ),
            cnae: {
              id: values?.cnae
            },
            nationalService: {
              id: values?.nationalService,
            },
            nbs: {
              id: values?.nbs,
            },
            issAliquot: Number(
              values.simplesNacional
                ? 0
                : values?.issAliquot?.replaceAll(".", "").replaceAll(",", "."),
            ),
            issRetained: values?.iss === "true",
            otherDeductions: Number(
              values?.otherDeductions?.replaceAll(".", "").replaceAll(",", "."),
            ),
            serviceValue: Number(
              values?.serviceValue?.replaceAll(".", "").replaceAll(",", "."),
            ),
            unconditionalDiscount: Number(
              values?.unconditionalDiscount
                ?.replaceAll(".", "")
                .replaceAll(",", "."),
            ),
            // Dados de obra
            ...(values?.obraTipo ? {
              obraTipo: values.obraTipo,
              obraCodigo: values.obraTipo === "CODIGO" ? values.obraCodigo : undefined,
              obraInscricaoImobFisc: values.obraInscricaoImobFisc || undefined,
              obraAddress: values.obraTipo === "ENDERECO" && values.obraAddress ? {
                place: values.obraAddress.place,
                district: values.obraAddress.district,
                number: values.obraAddress.number,
                complement: values.obraAddress.complement,
                city: values.obraAddress.city,
                state: values.obraAddress.state,
                zipCode: values.obraAddress.zipCode?.replace(/\D/g, ""),
                tipoLogradouro: values.obraAddress.tipoLogradouro,
              } : undefined,
            } : {}),
          },
        ],
        taker: {
          id: values?.taker?.id,
        },
        competencia: values?.competencia,
        emissionDate: values?.emissionDate,
        hasRecurrence: false,
        hasNationalFiscal: values.nfseType === NFSeTypeEnum.NFS_E_NACIONAL,
        ...(values?.naturezaOperacao && values.naturezaOperacao !== "normal"
          ? { naturezaOperacao: values.naturezaOperacao }
          : {}),
      };

      await makeRemoteFiscalNote().create(toSend);
      setShowConfirm(true);
      setTimeout(() => {
        setShowConfirm(false);
        history.push("/issue");
      }, 6000);
      toastUtils.showMessage({
        type: "success",
        message: "Gerando com Sucesso!",
      });
    } catch (error: any) {
      const errorMessage = getErrorMessage(error);
      toastUtils.showMessage({
        type: "error",
        message: errorMessage,
      });
    }
    setSubmitting(false);
  };
  return (
    <IssueForm
      loading={false}
      handleSubmit={handleSubmit}
      developerCompaniesList={developerCompaniesList}
      submitting={submitting}
    />
  );
};

export default MakeIssue;
